import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { RoutingPathsTree } from '@core/constants/routing-paths-tree.const';
import { UsersService } from '@core/services/users.service';
import { filter, map, Observable, take } from 'rxjs';

@Injectable()
export class NoAccessGuard implements CanActivate {
    constructor(private usersService: UsersService, private router: Router) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        return this.usersService.isAuthorizeChanges().pipe(
            take(2),
            filter((data) => data !== null),
            map((value: boolean | null) => {
                if (value) {
                    this.router.navigate([RoutingPathsTree.Home.route]);
                    return false;
                } else {
                    return true;
                }
            })
        );
    }
}
